// Configuracion de version de la aplicacion
// ✅ MEJORADO: Leer version dinamicamente desde VERSION.md
let APP_VERSION = "2.0.2"; // Fallback por defecto - Actualizado: 2026-01-13

// ✅ FUNCIÓN PARA OBTENER VERSIÓN ACTUAL DESDE VERSION.md
const getCurrentVersion = () => {
  try {
    // Intentar leer desde el contexto de compilación
    if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_VERSION) {
      return process.env.REACT_APP_VERSION;
    }
    
    // Fallback: usar versión hardcodeada actualizada
    return APP_VERSION;
  } catch (error) {
    console.warn('Error obteniendo versión:', error);
    return APP_VERSION;
  }
};

// ✅ ACTUALIZAR VERSIÓN DINÁMICAMENTE
APP_VERSION = getCurrentVersion();

export { APP_VERSION };
export const VERSION_LABEL = "Versión";

// Función para obtener el texto completo de la versión
export const getVersionText = () => {
  return `${VERSION_LABEL} ${APP_VERSION}`;
};

// Función para obtener solo el número de versión
export const getVersionNumber = () => {
  return APP_VERSION;
};

// Función para obtener solo el label de versión
export const getVersionLabel = () => {
  return VERSION_LABEL;
};